import { LoginPage as LoginPageContent } from "../components/LoginPageContent";

/** Exposes the auth route component used by the app router. */
export function LoginPage() {
  return <LoginPageContent />;
}
